<input
  #input
  (change)="_onInputInteraction($event)"
  [attr.name]="name"
  [attr.value]="value"
  [checked]="checked"
  [class.csl-visually-hidden-input]="isHidden"
  [disabled]="disabled && !disabledInteractive"
  [id]="inputId"
  [required]="required"
  type="radio"
/>
<label [for]="inputId" [ngClass]="{ 'text-[--input-label-disabled-color]': disabled }">
  <ng-content></ng-content>
</label>
